import TopBar from "@/components/top-bar";
import termsData from "@/data/terms-fa.json";

export default function TermOfConditionsPage() {
  return (
    <div className="content-container bg-background">
      <TopBar title={"قوانین و مقررات و حریم خصوصی"} />

      <section className="p-6 space-y-4">
        <h2 className="font-bold text-primary">
          {termsData.publicConditions.title}
        </h2>
        <ol className="list-disc pr-4 space-y-4 leading-7 text-sm text-default-800">
          {termsData.publicConditions.items.map((term: string, idx: number) => (
            <li key={idx}>{term}</li>
          ))}
        </ol>
      </section>

      {termsData.publicPrivacyPolicy && (
        <section className="p-6 space-y-4">
          <h2 className="font-bold text-primary">
            {termsData.publicPrivacyPolicy.title}
          </h2>
          <ol className="list-decimal pr-4 space-y-4 leading-7 text-sm text-default-800">
            {termsData.publicPrivacyPolicy.items.map((item: string, idx: number) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        </section>
      )}

      {termsData.publisherConditions && (
        <section className="p-6 space-y-4">
          <h2 className="font-bold text-primary">
            {termsData.publisherConditions.title}
          </h2>
          <ol className="list-decimal pr-4 space-y-4 leading-7 text-sm text-default-800">
            {termsData.publisherConditions.items.map((item: string, idx: number) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        </section>
      )}

      {termsData.publisherPrivacyPolicy && (
        <section className="p-6 space-y-4">
          <h2 className="font-bold text-primary">
            {termsData.publisherPrivacyPolicy.title}
          </h2>
          <ol className="list-decimal pr-4 space-y-4 leading-7 text-sm text-default-800">
            {termsData.publisherPrivacyPolicy.items.map((item: string, idx: number) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        </section>
      )}

      {/* {termsData.financialRules && (
        <section className="p-6 space-y-4">
          <h2 className="font-bold text-primary">
            {termsData.financialRules.title}
          </h2>
          <ol className=" space-y-4 leading-7 text-sm text-default-800">
            {termsData.financialRules.items.map(
              (item: { title: string; items: string[] }, idx: number) => (
                <li key={idx}>
                  <h3 className="font-bold text-primary">{item.title}</h3>
                  <ol className="list-disc pr-4 space-y-4 leading-7 text-sm text-default-800 ">
                    {item.items.map((entry: string, entryIdx: number) => (
                      <li key={entryIdx} className="whitespace-pre-wrap">
                        {entry}
                      </li>
                    ))}
                  </ol>
                </li>
              ),
            )}
          </ol>
        </section>
      )} */}
    </div>
  );
}
